import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';

import { Message } from '@core/objects/message'
import { MessagesService } from '@core/services/messages/messages.service';
import { VersionFeedback } from '@core/models/version-feedback';

import * as flContexts from '@core/constants/files-list-contexts.constants';

import * as VS from '@core/models/version-share.model';

@Component({
    selector: 'core-message',
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.scss']
})
export class MessageComponent implements OnInit{


    @Input() message: Message;
    @Input() delete: boolean = false;
    @Input() canCreateNotes: boolean = true;
    @Input() notesActionText: string;
    @Input() notesActionStyle: string;
    @Input() prefixUrl: string = '';
    @Input() prefixDeleteUrl: string; // only for context 'message-share-feedback' (CTX.MESSAGE_FEEDBACK)
    @Input() feedback:  VersionFeedback = null;
    @Input() versionShares:  Array<VS.VersionShare>;
    @Input() context: string = flContexts.CTX.MESSAGE_DEFAULT;


    @Output() onDelete = new EventEmitter<Message>();

    /**
     * Emitted when file signatures need to be refreshed
     * Bubbles up from MessageFilesComponent when core-signed-files-list detects expired signature
     */
    @Output() refreshSignaturesNeeded = new EventEmitter<void>();

    public working: boolean = false;
    public error: boolean = false;
    public success: boolean = false;
    public removed: boolean = false;
    // public beforeReset: boolean = false;

    public menu: Array<ThreeDotsMenuItem> = [
        {
            title: "Remove Message",
            key: "remove-message",
            icon: "remove-message"
        }
    ];


    constructor(private messagesSrv: MessagesService) {}

    ngOnInit(): void {
        // 05/10/2023 <diego@twonas.com> solved to manage delete message
        if (!this.prefixDeleteUrl || this.prefixDeleteUrl == ''){
            this.prefixDeleteUrl = this.prefixUrl;
        }
        this.checkBeforeResetMessages();
    }

    onMenuClick(key: string,message: Message) {
        switch(key) {
            case "remove-message":
                console.debug(" delete message ", key,message)
                this.remove(message)
                break;
        }
    }

    remove(msg: Message) {
        this.working = true;
        this.removed = true;
        this.messagesSrv.remove(msg,this.prefixDeleteUrl,this.context).subscribe(
            (data: Message) => {
                console.log('Message removed: '+data);
                this.onDelete.emit(msg);
                this.working = false;
                this.setSuccess(true);
            },
            (error:any) => {
                console.log('Error removing message: '+error);
                this.working = false;
                this.error = true;
                this.removed = false;
            }
        );
    }

    private checkBeforeResetMessages(){
        // we dont have to check the version-upload shares date
        const shareFeedback = this.versionShares?.find( (vs:VS.VersionShare) => (vs.type != VS.VersionShareType.UPLOAD_VERSION_TYPE && (
            (vs.type == VS.VersionShareType.FEEDBACK_TYPE && vs.status.status_code ==  VS.FeedbackStatusCodeEnum.OPENED_CODE )
            || (vs.type == VS.VersionShareType.APPROVAL_TYPE && vs.status.status_code == VS.ApprovalStatusCodeEnum.PENDING_CODE)
            )
        ) );
        // removed25/6/2024 <diego@twonas.com> fix for dimmed meesages beofre reset date
        // if(shareFeedback){
        //     this.beforeReset = new Date(this.message.date) < new Date(shareFeedback.status.date);
        // }
    }

    private setSuccess(success: boolean) {
        this.success = success;
        setTimeout(()=>{
            this.success = false;
        }, 1000);
    }

    try(){
        this.error = false;
    }

    /**
     * Handle refresh signatures needed from MessageFilesComponent
     * Emits signal to parent so files can be reloaded with fresh signatures
     */
    onRefreshSignaturesNeeded(): void {
        console.debug('[MessageComponent] Forwarding refresh signatures needed to parent');
        this.refreshSignaturesNeeded.emit();
    }

}
